import Injector from 'vue-inject';
import numeral from 'numeral';
import Debug from '@/util/debug';
import { ENV_IS_DEVELOPMENT, LOCALE_DEVELOPMENT, LOCALE_DEFAULT } from '@/util/constants';
import * as LocalStorage from '@/util/local-storage';
import Vue from 'vue';

const debug = Debug('service:Locale');

export default class LocaleService {
  constructor(vue, aas) {
    this.vue = vue;
    this.adApiService = aas;
    this.locales = null; // translations from adapi
    this.languages = []; // available languages
    this.eventBus = new Vue();
  }

  getEventBus() {
    return this.eventBus;
  }

  loadLocalesFromApi() {
    debug.info('loadLocalesFromApi');
    return this.adApiService.getLocales()
      .catch(err => {
        debug.error('Could not load Locales', err);
        return [];
      })
      .then(locales => {
        this.locales = locales;
        return locales;
      });
  }

  getLocales() {
    debug.info('getLocales', this.locales);
    if (this.locales === null) {
      return this.loadLocalesFromApi();
    }

    return new Promise(resolve => resolve(this.locales));
  }

  changeLocale(locale) {
    debug.info('changing language to %s', locale);
    this.vue.$i18n.i18next.changeLanguage(locale);
    this.eventBus.$emit('language-changed', locale);
    numeral.locale(locale);
    return LocalStorage.set('locale', locale);
  }

  setLanguages(languages) {
    // Set default language array
    const newLangs = languages && languages.length ? languages : [LOCALE_DEFAULT];
    this.languages = ENV_IS_DEVELOPMENT ? newLangs.concat(LOCALE_DEVELOPMENT) : newLangs;
  }

  getLanguages() {
    return this.languages;
  }

  setUserLanguage() {
    return this.getUserLanguage().then(language => this.changeLocale(language));
  }

  getUserLanguage() {
    return LocalStorage.get('locale')
      .then(locale => {
        let userLocale = LOCALE_DEFAULT; // Default language
        if (this.languages.indexOf(locale) >= 0) {
          userLocale = locale;
        } else if (this.languages.length) {
          // Currently we don't pass default language, so use first available
          userLocale = this.languages[0];
        }
        return userLocale;
      });
  }

  translateInLocale(locale, text, params = {}) {
    const t = this.vue.$i18n.i18next.getFixedT(locale);
    return t(text, params);
  }

  updateTranslations(translations) {
    Object.keys(translations).forEach(language => {
      this.vue.$i18n.i18next.addResources(language, 'translation', translations[language]);
      debug.info('Updated language "%s" translations to: %o', language, translations[language]);
    });
  }
}

Injector.service('localeService', ['$context', 'adApiService'], LocaleService);



// WEBPACK FOOTER //
// ./src/services/LocaleService.js